import * as types from './types';

export const setPrimaryParameterName = parameterName => ({
  type: types.SET_PRIMARY_PARAMETER_NAME, parameterName
});

export const setSecondaryParameterName = parameterName => ({
  type: types.SET_SECONDARY_PARAMETER_NAME, parameterName
});

export const setTypeFrequencyBarChart = typeOfFrequencyBarChart => ({
  type: types.SET_TYPE_FREQUENCY_BAR_CHART, typeOfFrequencyBarChart
});

export const setTypeFrequencyPieChart = typeOfFrequencyPieChart => ({
  type: types.SET_TYPE_FREQUENCY_PIE_CHART, typeOfFrequencyPieChart
});

export const setTypeFrequencyHistogram = typeOfFrequencyHistogram => ({
  type: types.SET_TYPE_FREQUENCY_HISTOGRAM, typeOfFrequencyHistogram
});
